var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { ApolloConsumer } from 'react-apollo';
import gql from 'graphql-tag';
import { ROLE } from 'shared/types';
import { transformErrorToObject } from 'shared/error';
import { GET_BOARDS } from '.';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 70px;\n  padding: 10px;\n  line-height: 50px;\n\n  > form {\n    > ul {\n      width: 100%;\n      height: 50px;\n\n      > li {\n        float: left;\n        font-size: 16px;\n        text-align: center;\n\n        > input {\n          width: 90%;\n          height: 50px;\n          padding: 10px;\n          font-size: 16px;\n        }\n\n        > select {\n          width: 90%;\n          height: 50px;\n        }\n\n        > button {\n          all: unset;\n          cursor: pointer;\n          box-sizing: border-box;\n          width: 90%;\n          height: 50px;\n          line-height: 30px;\n          padding: 10px;\n          font-size: 16px;\n          background: #36c;\n          color: #fff;\n          border-radius: 10px;\n        }\n\n        > .cancel-btn {\n          background: #d00;\n        }\n      }\n    }\n\n    > .error {\n      margin-top: 10px;\n      width: 100%;\n      height: 30px;\n      line-height: 30px;\n      color: red;\n    }\n  }\n"], ["\n  width: 100%;\n  height: 70px;\n  padding: 10px;\n  line-height: 50px;\n\n  > form {\n    > ul {\n      width: 100%;\n      height: 50px;\n\n      > li {\n        float: left;\n        font-size: 16px;\n        text-align: center;\n\n        > input {\n          width: 90%;\n          height: 50px;\n          padding: 10px;\n          font-size: 16px;\n        }\n\n        > select {\n          width: 90%;\n          height: 50px;\n        }\n\n        > button {\n          all: unset;\n          cursor: pointer;\n          box-sizing: border-box;\n          width: 90%;\n          height: 50px;\n          line-height: 30px;\n          padding: 10px;\n          font-size: 16px;\n          background: #36c;\n          color: #fff;\n          border-radius: 10px;\n        }\n\n        > .cancel-btn {\n          background: #d00;\n        }\n      }\n    }\n\n    > .error {\n      margin-top: 10px;\n      width: 100%;\n      height: 30px;\n      line-height: 30px;\n      color: red;\n    }\n  }\n"])));
var CREATE_BOARD = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation CreateBoard($board: CreatingBoardPayload!) {\n    createProjectBoard(board: $board)\n  }\n"], ["\n  mutation CreateBoard($board: CreatingBoardPayload!) {\n    createProjectBoard(board: $board)\n  }\n"])));
var BoardWriter = /** @class */ (function (_super) {
    __extends(BoardWriter, _super);
    function BoardWriter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.write = function (values, client) { return __awaiter(_this, void 0, void 0, function () {
            var _a, project, pageId, pageName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, project = _a.project, pageId = _a.pageId, pageName = _a.pageName;
                        return [4 /*yield*/, client.mutate({
                                mutation: CREATE_BOARD,
                                variables: {
                                    board: __assign({}, values, { writableRole: Number(values.writableRole), pageId: pageId, projectName: project })
                                },
                                refetchQueries: [{
                                        query: GET_BOARDS,
                                        variables: {
                                            pageName: pageName,
                                            projectName: project,
                                        }
                                    }]
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    BoardWriter.prototype.render = function () {
        var _a = this.props, name = _a.name, urlName = _a.urlName, type = _a.type, writableRole = _a.writableRole, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
        var submit = onSubmit || this.write;
        return (React.createElement(Container, null,
            React.createElement(ApolloConsumer, null, function (client) { return (React.createElement(Formik, { initialValues: {
                    name: name || '',
                    urlName: urlName || '',
                    type: type || '',
                    writableRole: writableRole || '',
                }, onSubmit: function (values, actions) {
                    submit(values, client).then(function () {
                        actions.setSubmitting(false);
                    }, function (err) {
                        actions.setSubmitting(false);
                        actions.setErrors(transformErrorToObject(err));
                    });
                }, validate: function (values) {
                    var errors = {};
                    if (!values.name) {
                        errors.name = '게시판 이름을 입력하세요.';
                    }
                    if (!values.urlName) {
                        errors.urlName = '영어 이름을 입력하세요.';
                    }
                    if (!values.urlName.match(/^[a-z0-9\-]*$/)) {
                        errors.urlName = '영어 이름은 소문자 알파벳과 - 만 사용 가능합니다.';
                    }
                    if (!values.type) {
                        errors.type = '유형을 지정해야 합니다.';
                    }
                    if (!values.writableRole) {
                        errors.writableRole = '쓰기 권한을 지정해야 합니다.';
                    }
                    return errors;
                } }, function (_a) {
                var isSubmitting = _a.isSubmitting;
                return (React.createElement(Form, null,
                    React.createElement("ul", null,
                        React.createElement("li", { style: { width: '20%' } },
                            React.createElement(Field, { placeholder: "\uAC8C\uC2DC\uD310 \uC774\uB984", name: "name" })),
                        React.createElement("li", { style: { width: '15%' } },
                            React.createElement(Field, { placeholder: "\uC601\uC5B4 \uC774\uB984(URL)", name: "urlName" })),
                        React.createElement("li", { style: { width: '15%' } },
                            React.createElement(Field, { component: "select", name: "type" },
                                React.createElement("option", { value: "" }, "[\uC720\uD615]"),
                                React.createElement("option", { value: "Board" }, "\uAC8C\uC2DC\uD310\uD615"),
                                React.createElement("option", { value: "Gallery" }, "\uAC94\uB7EC\uB9AC\uD615"))),
                        React.createElement("li", { style: { width: '20%' } },
                            React.createElement(Field, { component: "select", name: "writableRole" },
                                React.createElement("option", { value: "" }, "[\uC4F0\uAE30 \uAD8C\uD55C]"),
                                React.createElement("option", { value: ROLE.ADMINISTRATOR }, "\uCD5C\uACE0\uAD00\uB9AC\uC790"),
                                React.createElement("option", { value: ROLE.MANAGER }, "\uB9E4\uB2C8\uC800"),
                                React.createElement("option", { value: ROLE.MEMBER }, "\uD68C\uC6D0"))),
                        onCancel
                            ? (React.createElement(React.Fragment, null,
                                React.createElement("li", { style: { width: '15%' } },
                                    React.createElement("button", { type: "submit", disabled: isSubmitting }, "\uC218\uC815")),
                                React.createElement("li", { style: { width: '15%' } },
                                    React.createElement("button", { className: "cancel-btn", onClick: onCancel }, "\uCDE8\uC18C"))))
                            : (React.createElement("li", { style: { width: '30%' } },
                                React.createElement("button", { type: "submit", disabled: isSubmitting }, "\uAC8C\uC2DC\uD310 \uCD94\uAC00")))),
                    React.createElement(ErrorMessage, { name: "name", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                    React.createElement(ErrorMessage, { name: "urlName", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                    React.createElement(ErrorMessage, { name: "type", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                    React.createElement(ErrorMessage, { name: "writableRole", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } })));
            })); })));
    };
    return BoardWriter;
}(React.Component));
export default BoardWriter;
var templateObject_1, templateObject_2;
